import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '@/assets/discuss/empty.png';
var _hoisted_1 = {
  class: "guan-report"
};
var _hoisted_2 = {
  class: "report-search"
};
var _hoisted_3 = {
  key: 1,
  class: "empty-box"
};
import { MessagePlugin } from 'tdesign-vue-next';
import dayjs from 'dayjs';
import { ref, reactive, watch } from 'vue';
import WujieVue from 'wujie-vue3';
import { env_name } from '@/util/util.js';
/** 接口 */
import { getLessonList } from '@/api/index-guan.js';
import { appAliasInfo } from '@/utils/auth';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var bus = WujieVue.bus;
    var form = reactive({
      startDate: dayjs().subtract(6, 'day').format('YYYY-MM-DD'),
      endDate: dayjs().format('YYYY-MM-DD')
    });
    // 分页
    var pageObj = reactive({
      total: 0,
      current: 1,
      size: 20
    });
    // 表格数据
    var tableData = ref([]);
    // 表格加载状态
    var tableLoading = ref(false);
    // 课堂报告table表头数据
    var COLUMNS = [{
      title: '授课班级',
      colKey: 'className',
      ellipsis: true
    }, {
      title: '毕业年份',
      colKey: 'classFinishYear',
      ellipsis: true
    }, {
      title: '授课学科',
      colKey: 'subjectDictItemName',
      ellipsis: true
    }, {
      title: '授课时长',
      colKey: 'classTimeLength',
      ellipsis: true
    }, {
      title: '授课日期',
      colKey: 'startDate',
      ellipsis: true
    }, {
      title: '开始时间',
      colKey: 'timeStart',
      ellipsis: true
    }, {
      title: '结束时间',
      colKey: 'timeEnd',
      ellipsis: true
    }, {
      title: '操作',
      colKey: 'operation',
      align: 'center',
      width: 120,
      fixed: 'right'
    }];
    /** watch监听 */
    watch([function () {
      return form.startDate;
    }, function () {
      return form.endDate;
    }], function (nval) {
      if (nval[0] && nval[1]) {
        var timeOne = new Date(nval[0]).getTime();
        var timeTwo = new Date(nval[1]).getTime();
        if (timeOne > timeTwo) {
          form.startDate = nval[1];
          form.endDate = nval[0];
        }
        handleSearch();
      }
    });
    var hasReportsAuth = ref(false);
    /** 方法 */
    var geCollAuth = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$appAliasInfo, hasAuth, menus, index, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return appAliasInfo('classReports');
            case 1:
              _yield$appAliasInfo = _context.v;
              hasAuth = _yield$appAliasInfo.hasAuth;
              menus = _yield$appAliasInfo.menus;
              if (hasAuth) bus.$emit('show-enter-class-report', true);
              if (hasAuth && menus) {
                index = menus.findIndex(function (itm) {
                  return itm.path === '/report';
                });
                hasReportsAuth.value = index > -1;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              MessagePlugin.error('获取权限异常');
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      return function geCollAuth() {
        return _ref.apply(this, arguments);
      };
    }();
    geCollAuth();
    /**
     * 列表
     */
    var getList = function getList() {
      tableLoading.value = true;
      var data = {
        current: pageObj.current,
        size: pageObj.size,
        startDate: form.startDate,
        endDate: form.endDate
      };
      getLessonList(data).then(function (res) {
        if (res.data.code === 0) {
          tableData.value = res.data.data.records;
          pageObj.total = res.data.data.total;
          tableLoading.value = false;
        }
      });
    };
    getList();
    /**
     * 筛选条件日期
     */
    var handleSearch = function handleSearch(val) {
      pageObj.current = 1;
      getList();
    };
    /**
     * 重置
     */
    var reset = function reset() {
      form.startDate = dayjs().subtract(6, 'day').format('YYYY-MM-DD');
      form.endDate = dayjs().format('YYYY-MM-DD');
      handleSearch();
    };
    /**
     * 分页
     */
    var changePage = function changePage(info) {
      pageObj.current = info.current;
      pageObj.size = info.pageSize;
      getList();
    };
    /**
     * 详情
     */
    var handleDetail = function handleDetail(row) {
      var commonName = env_name ? "//".concat(env_name, "web.zhixuehuijiao.cn") : '//web.zhixuehuijiao.cn';
      window.open("".concat(commonName, "/classReports?classReports=%2FreportDetail%3FlessonId%3D").concat(row.lessonId));
    };
    return function (_ctx, _cache) {
      var _component_t_date_picker = _resolveComponent("t-date-picker");
      var _component_t_button = _resolveComponent("t-button");
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_table = _resolveComponent("t-table");
      var _component_t_pagination = _resolveComponent("t-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [hasReportsAuth.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_2, [_cache[3] || (_cache[3] = _createTextVNode(" 起止时间 ", -1)), _createVNode(_component_t_date_picker, {
        modelValue: form.startDate,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return form.startDate = $event;
        }),
        class: "w-132 mar-l16",
        placeholder: "开始时间",
        format: "YYYY-MM-DD",
        clearable: ""
      }, null, 8, ["modelValue"]), _cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "mar-4"
      }, "-", -1)), _createVNode(_component_t_date_picker, {
        modelValue: form.endDate,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return form.endDate = $event;
        }),
        class: "w-132",
        placeholder: "结束时间",
        format: "YYYY-MM-DD",
        clearable: ""
      }, null, 8, ["modelValue"]), _createVNode(_component_t_button, {
        class: "mar-l16",
        theme: "default",
        onClick: reset
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[2] || (_cache[2] = [_createTextVNode("重置", -1)]));
        }),
        _: 1
      })]), _createVNode(_component_t_table, {
        loading: tableLoading.value,
        rowKey: "id",
        columns: COLUMNS,
        data: tableData.value,
        class: "report-table",
        height: "calc(100vh - 198px)"
      }, {
        operation: _withCtx(function (_ref2) {
          var row = _ref2.row;
          return [_createVNode(_component_t_button, {
            variant: "text",
            theme: "primary",
            onClick: function onClick($event) {
              return handleDetail(row);
            }
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[5] || (_cache[5] = [_createTextVNode("详情", -1)]));
            }),
            _: 1
          }, 8, ["onClick"])];
        }),
        empty: _withCtx(function () {
          return [_createVNode(_component_svg_icon, {
            name: "empty-table",
            size: "120"
          })];
        }),
        _: 1
      }, 8, ["loading", "data"]), _createVNode(_component_t_pagination, {
        class: "report-page",
        showJumper: "",
        current: pageObj.current,
        pageSize: pageObj.size,
        total: pageObj.total,
        pageSizeOptions: [20, 50, 100, 200, 500],
        onChange: changePage
      }, null, 8, ["current", "pageSize", "total"])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_3, _toConsumableArray(_cache[6] || (_cache[6] = [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }, null, -1), _createElementVNode("span", null, "暂无课堂报告菜单权限", -1)]))))]);
    };
  }
};